export function capitalize(str: string, lowerCaseRest = false) {
  if (!str) return "";

  const rest = lowerCaseRest ? str.slice(1).toLowerCase() : str.slice(1);

  return str.charAt(0).toUpperCase() + rest;
}
